import { Injectable } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';
import { of } from 'rxjs';
import esArTranslations from '../../assets/i18n/es-AR.json';
import esMxTranslations from '../../assets/i18n/es-MX.json';
import ptTranslations from '../../assets/i18n/pt.json';

const translations = {
  esAr: esArTranslations,
  esMx: esMxTranslations,
  pt: ptTranslations,
};

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {

  getTranslation(langPath: string) {
    const translationsByLang = translations[langPath] || esMxTranslations;

    return of(translationsByLang);
  }
}
